import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import {css} from '@emotion/react';
import {mobile, tablet} from '~styles/global';
import Vimeo from '~components/Vimeo';
import Image from '~components/Image';
import VimeoMobile from '~components/VimeoMobile';
import useBreakpoint from '~utils/useBreakpoint';

const PageHeader = ({className, content, relativeHeight}) => {
	const {isMobile, loaded} = useBreakpoint();

	if (!loaded) return null;

	if (content?.mediaType === 'video')
		return (
			<Wrap className={className} relativeHeight={relativeHeight}>
				{isMobile ? <StyledVimeoMobile videoId={content?.video?.oEmbedData?.video_id} aspectRatio={content?.video?.oEmbedData?.width / content?.video?.oEmbedData?.height} placeholder={content?.image} /> : <Vimeo videoId={content?.video?.oEmbedData?.video_id} aspectRatio={content?.video?.oEmbedData?.width / content?.video?.oEmbedData?.height} relativeHeight={relativeHeight} placeholder={content?.image} width={content?.video?.oEmbedData?.width} height={content?.video?.oEmbedData?.height} showControls={content?.showControls} />}
			</Wrap>
		);
	return (
		<Wrap className={className} relativeHeight={relativeHeight}>
			<StyledImage image={content?.image} cover relativeHeight={relativeHeight} />
		</Wrap>
	);
};

const Wrap = styled.div`
	height: ${(props) => (props.relativeHeight ? 'auto' : '100vh')};
	overflow-x: hidden;
	${mobile} {
		background-color: var(--black);
		display: flex;
		align-items: center;
		padding: 170px 0 150px;
		height: auto;
	}
`;
const StyledVimeoMobile = styled(VimeoMobile)`
	width: 100%;
`;
const StyledImage = styled(Image)`
	height: ${(props) => (props.relativeHeight ? '100%' : '100vh')};
	${mobile} {
		height: auto;
	}
`;

PageHeader.propTypes = {
	className: PropTypes.string,
	content: PropTypes.object,
	relativeHeight: PropTypes.bool,
};

export default PageHeader;
